import { adminApi } from "../../api/admin";

interface Props {
  scopeType: string;
  scopeId: string;
  onChange: (next: { scope_type: string; scope_id: string }) => void;
}

export function ScopePicker({ scopeType, scopeId, onChange }: Props) {
  const types = adminApi.scopes.types();
  const choices = adminApi.scopes.choices(scopeType);

  const availableTypes = (types.data ?? []).filter((t) => t.available);
  const reservedTypes = (types.data ?? []).filter((t) => !t.available);

  const selectedChoice = choices.data?.find((c) => c.scope_id === scopeId);

  return (
    <div>
      <label className="label">Scope</label>
      <div className="flex flex-wrap gap-2 mb-2">
        {availableTypes.map((t) => (
          <button
            key={t.type_name}
            type="button"
            className={`tag-chip ${
              t.type_name === scopeType
                ? "bg-accent-subtle border-accent"
                : ""
            }`}
            onClick={() => onChange({ scope_type: t.type_name, scope_id: "" })}
          >
            {t.type_name}
          </button>
        ))}
        {reservedTypes.map((t) => (
          <span
            key={t.type_name}
            className="tag-chip opacity-50 cursor-not-allowed"
            title={`${t.type_name} is reserved and not yet available`}
          >
            {t.type_name} <span className="text-xs">(soon)</span>
          </span>
        ))}
      </div>

      {choices.isLoading ? (
        <p className="text-sm text-ink-low">Loading {scopeType} choices…</p>
      ) : choices.error ? (
        <p className="text-sm text-danger">
          Failed to load {scopeType} choices: {(choices.error as Error).message}
        </p>
      ) : (
        <select
          className="input"
          value={scopeId}
          onChange={(e) =>
            onChange({ scope_type: scopeType, scope_id: e.target.value })
          }
        >
          <option value="">Pick a {scopeType}…</option>
          {(choices.data ?? []).map((c) => (
            <option
              key={c.scope_id}
              value={c.scope_id}
              disabled={!!c.disabled_reason}
            >
              {c.label}
              {c.sublabel ? ` — ${c.sublabel}` : ""}
              {c.disabled_reason ? ` (${c.disabled_reason})` : ""}
            </option>
          ))}
        </select>
      )}

      {selectedChoice?.disabled_reason ? (
        <p className="mt-2 text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded p-2">
          <strong>Heads up:</strong> {selectedChoice.disabled_reason}.
          Configure this scope before saving the cron — fix it on the{" "}
          {scopeType === "campaign" ? (
            <a
              className="underline"
              href={`/admin/campaigns/${selectedChoice.scope_id}`}
            >
              campaign admin
            </a>
          ) : (
            <span>relevant admin page</span>
          )}
          .
        </p>
      ) : null}
    </div>
  );
}
